<template>
 <FormCol field="card" :showLabel="false" :check_text="checkText"/>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    checkText: String
  },
})
</script>

<style scoped lang="scss">
::v-deep() input {
    background: white;
}
</style>
